<template>
  <NuxtLayout
    name="generic"
    header="standardDark"
    footer="standard"
  >
    <div
      v-if="data"
      :class="{
        'tech-tip-template mt-14 bg-www-color-neutral-off-white md:mt-120px': true,
      }"
    >
      <BreadCrumbFromRoute
        :class="{
          'hero-container': true,
        }"
        :title="data.title"
      />

      <BlogHero
        v-if="data.blogHero"
        :blog-hero="data.blogHero"
      />

      <PortableText
        :class="{
          'text-www-color-neutral-medium-dark': true,
        }"
        :portable-data="data.content?.blogPortableText || []"
      />

      <CTABanner
        v-if="data.CTABanner?.reference"
        :data="data.CTABanner.reference"
      />
      <SuggestedContent
        v-if="!data.removeSuggestedContent"
        :suggested-title="data.suggestedContentTitle"
        :current-id="data._id"
      />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import type { QueryTechTipResult } from '~/sanity/types';
import { queryTechTip } from '~/queries/pages/PageTechTip.query';
import BreadCrumbFromRoute from '~/components/Atoms/BreadCrumb/BreadCrumbFromRoute.vue';
import BlogHero from '~/components/Organisms/BlogHero/BlogHero.vue';
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import CTABanner from '~/components/Organisms/CTABanner/CTABanner.vue';
import SuggestedContent from '~/components/Organisms/SuggestedContent/SuggestedContent.vue';
import { extractAbstractFromPortableText } from '~/utils/extractBreakoutSummary';

const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQueryNonNull<QueryTechTipResult>(queryTechTip, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  author: data.value?.blogHero.person?.reference?.name,
  title: data.value?.htmlTitle || data.value?.title,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset || data.value?.cardImage?.asset || data.value?.heroImage?.asset,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  dateModified: data.value?._updatedAt,
  datePublished: data.value?.articleDate,
  authorImage: data.value?.blogHero.person?.reference?.headshot,
  twitterCard: 'summary',
  structuredData: [
    {
      schemaType: 'NewsArticle',
      title: data.value?.htmlTitle || data.value?.title,
      description: data.value?.ogDescription || data.value?.description,
      contentSummary: data.value?.description,
      abstract: extractAbstractFromPortableText(data.value?.content?.blogPortableText),
      imageRef: data.value?.ogImage?.asset?._ref || data.value?.cardImage?.asset?._ref,
      authorName: data.value?.blogHero.person?.reference?.name,
      dateModified: data.value?._updatedAt,
      datePublished: data.value?.articleDate,
      articleSection: data.value?.blogHero.taxonomies?.[0]?.prefLabel,
      keywords: data.value?.blogHero.taxonomies?.map((taxonomy) => taxonomy.prefLabel),
      enabled: true,
    },
  ],
});
</script>
